import styled from '@emotion/styled'
import theme from '@utils/theme'

const BannerContainer = styled.div`
  margin-top: 40px;
  width: 100%;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  background-color: white;
  margin: 0 auto;
`

const Title = styled.h2`
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 24px;
  color: #333;
`

const ToggleContainer = styled.div`
  display: flex;
  margin-bottom: 24px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #e0e0e0;
`

interface ToggleButtonProps {
  active?: boolean
}

const ToggleButton = styled.button<ToggleButtonProps>`
  flex: 1;
  padding: 12px;
  background-color: ${(props) =>
    props.active ? theme.colors.primary : 'white'};
  color: ${(props) => (props.active ? 'white' : '#333')};
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: ${(props) => (props.active ? '600' : '400')};

  &:hover {
    background-color: ${(props) =>
      props.active ? theme.colors.primary : '#f5f5f5'};
  }
`

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const FieldWrapper = styled.div`
  margin-bottom: 16px;
`

const SubmitButton = styled.div`
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
`

// Styled components for DeleteBanner
const DeleteBannerSection = styled.div`
  margin-top: 40px;
  border-top: 1px solid #e0e0e0;
  padding-top: 24px;
`

const SectionTitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #333;
`

const BannerImageContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 24px;
`

interface BannerImageWrapperProps {
  isSelected: boolean
}

const BannerImageWrapper = styled.div<BannerImageWrapperProps>`
  position: relative;
  width: 180px;
  height: 100px;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  border: ${(props) => (props.isSelected ? '2px solid #e74c3c' : 'none')};
  transition: border 0.2s ease-in-out;
  cursor: pointer;
`

const BannerImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const ActionContainer = styled.div`
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
`

const ConfirmContainer = styled.div`
  margin-top: 16px;
  padding: 16px;
  border-radius: 8px;
  background-color: #f8f9fa;
  border: 1px solid #e0e0e0;
`

const ConfirmMessage = styled.p`
  font-size: 16px;
  color: #333;
  margin-bottom: 16px;
`

const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
`

const EmptyState = styled.div`
  text-align: center;
  padding: 20px;
  color: #757575;
  background-color: #f5f5f5;
  border-radius: 6px;
`

export {
  BannerContainer,
  Title,
  ToggleContainer,
  ToggleButton,
  FormContainer,
  FieldWrapper,
  SubmitButton,
  DeleteBannerSection,
  SectionTitle,
  BannerImageContainer,
  BannerImageWrapper,
  BannerImage,
  ActionContainer,
  ConfirmContainer,
  ConfirmMessage,
  ButtonGroup,
  EmptyState,
}
